import React from "react";
import happy from "../../../assets/myAnalytics/happy.png";

const UserSentiments = (props) => {
  return (
    <div className="engagement-attension-card h-100">
      <h5 className="pb-3">
        User Sentiments
     
      </h5>
      <div className="d-flex justify-content-center mt-5">
        <div className="user-sentiments-metrics">
          <img height={40} width={40} src={happy} alt="" />
          <h2>
            {props?.emotions ? Math.round(props?.emotions?.[0]) : 0}{" "}
            <span>%</span>
          </h2>
        </div>
      </div>
    </div>
  );
};

export default UserSentiments;
